<template>
    <div v-if="tabs.length" class="mb-8">
        <ul class="flex justify-center mb-4">
            <li v-for="(tab, index) in tabs" :key="index" class="px-2">
                <a class="mx-2" href="#" :class="activeTab === index ? 'font-medium' : ''" @click.prevent="toggleTab(index)" v-html="tab.label">

                </a>
            </li>
        </ul>

        <div v-html="activeTabContent"></div>
    </div>
</template>
<script>
export default {
    data() {
		return {
            activeTab: 0,
            activeTabContent: "",
		}
	},
    computed: {
        tabs() {
            let tabs = window?.capes?.tabs ?? [];

            if( tabs[0].content ){
                this.activeTabContent = tabs[0].content;
            }

            return tabs;
        },
    },
    methods: {
        toggleTab(index){
            this.activeTab = index;
            this.activeTabContent = this.tabs[index].content;
        }
    }
}
</script>
